import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { formatSize } from "../../../../../config/global";
import { getFileIcon, MAX_FILE_LIMIT } from "../../../../../config/media";
import { useSelector } from "react-redux";

const FileList = ({ setCapacityAtOnce, capacityAtOnce, files, onRemoveFile, uploading }) => {
  const { t } = useTranslation();
  const { companyDetails } = useSelector((state) => state.global);

  const handleRemove = useCallback((index) => {
    setCapacityAtOnce(false)
    onRemoveFile(index);
  }, [onRemoveFile]);
 
  return (
    <div
      className="my-4 justify-start px-3 scroll_div pp-upload-file-list"
      style={{ maxHeight: '50vh', overflowY: 'auto' }}
    >
      <div className="flex items-center">
        <p className="uppercase text-[12px] font-[500] text-[#555] mb-0 ">
          {t('media.media_files_selected', { count: files.length })} ({formatSize(files.reduce((sum, file) => sum + file.size, 0))})
        </p>
        {
          files.length === 20 ?
            <small className="text-danger ms-2">
              {t('media.media_file_limit_reached', { count: MAX_FILE_LIMIT })}
            </small>
            :
            <></>
        }
        {
          capacityAtOnce ?
            <small className="text-danger ms-2">
              {t('media.media_capacity_at_once', { gb: Math.round(companyDetails.upload_once_content_capacity / (1024 * 1024 * 1024)) })}
            </small>
            :
            <></>
        }
      </div>
      {files.map((file, index) => (
        <div key={`${index}_${file.lastModified}`} className="shadow-md bg-white p-4 my-3 w-full flex items-center justify-between">
          <div className="flex items-center gap-4 w-[70%]">
            {file.type.includes("image") ? (
              <img src={URL.createObjectURL(file)} alt={file.name} className="h-[40px] w-[70px] object-cover" />
            ) : (
              getFileIcon(file.type)
            )}
            <div className="flex flex-col justify-start w-100">
              <span className="text-truncate">{file.name}</span>
            </div>
          </div>
          <button
            disabled={uploading}
            className="disabled:opacity-30"
            onClick={() => handleRemove(index)}
          >
            <i className="bx bx-trash text-light"></i>
          </button>
        </div>
      ))}
    </div>
  );
};

export default FileList;
